<template>
  <v-container fluid grid-list-md>
    <v-layout>
      <v-flex xs6>
        <v-card class="mb-2">
          <v-card-title style="padding:8px">新規申込申請</v-card-title>
          <v-card-actions>
            <v-btn :disabled="!agree" @click="save">申込</v-btn>
            <v-btn @click="download">申込書出力</v-btn>
            <v-btn @click="$refs.uploadDlg.show=true">申込書Upload</v-btn>
            <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
          </v-card-actions>
          <v-card-text>
            <v-form v-model="params.valid">
              <div required style="display:flex;">
                <v-text-field
                  :rules="[v=>!!v || ` 所属会社 is required`,]"
                  label="所属会社"
                  v-model.trim="params.comapnayReferName"
                />
              </div>
              <div style="display:flex;">
                <v-radio-group row v-model="isSJL">
                  <v-radio :value="true" label="SHARP"></v-radio>
                  <v-radio :value="false" label="Other"></v-radio>
                </v-radio-group>
              </div>
              <div required style="display:flex;">
                <v-text-field
                  :rules="[
                v=> /^[A-Za-z0-9]+$/.test(v) || `氏名CD must be valid`
                ]"
                  class="mr-1"
                  label="氏名CD"
                  v-model.trim="params.code"
                ></v-text-field>
                <v-text-field
                  :rules="[v => !!v || ` 氏名 is required`]"
                  label="氏名"
                  v-model.trim="params.fullName"
                ></v-text-field>
              </div>
              <div style="display:flex;">
                <v-text-field class="mr-1" label="表示名" v-model="params.showName"></v-text-field>
                <v-text-field
                  :rules="[
                v=> /^[A-Za-z0-9\s]+$/.test(v) || `英文氏名 must be valid`
                ]"
                  label="英文氏名"
                  v-model.trim="params.englishName"
                ></v-text-field>
              </div>
              <v-text-field
                :rules="[
                v => !!v || ` Email is required`, 
                v=> /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,10})+$/.test(v) || `E-mail must be valid`
                ]"
                label="Email"
                v-model.trim="params.email"
              ></v-text-field>

              <div style="display:flex">
                <v-text-field class="mr-1" label="外線電話番号" v-model.trim="params.outsideLineNumber"></v-text-field>
                <v-text-field label="内線電話番号" v-model.trim="params.insideLineNumber"></v-text-field>
              </div>
              <v-text-field label="役職" v-model.trim="params.position"></v-text-field>

              <v-select
                :items="languageItems"
                :rules="[v => !!v || ` 言語 is required`]"
                label="言語"
                v-model="params.language"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn :disabled="!params.valid" @click="$refs.agreeDlg.show=true">個人情報利用について</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <agree-dialog ref="agreeDlg" v-model="agree"/>
    <upload-dialog ref="uploadDlg"/>
    <register-download ref="register"></register-download>
    <english-print-dialog ref="printDlg"></english-print-dialog>
    <jp-print-dialog ref="jpPrintDlg"></jp-print-dialog>
    <sjl-print-dialog ref="sjlPrintDlg"></sjl-print-dialog>
  </v-container>
</template>
<script>
import AgreeDialog from './AgreeDialog'
import UploadDialog from './UploadDialog'
import RegisterDownload from './RegisterDownload'
import EnglishPrintDialog from './EnglishPrintDialog'
import JpPrintDialog from './JpPrintDialog'
import SjlPrintDialog from './SjlPrintDialog'
export default {
  components: {
    AgreeDialog,
    UploadDialog,
    RegisterDownload,
    EnglishPrintDialog,
    JpPrintDialog,
    SjlPrintDialog
  },
  data() {
    return {
      companyType: null,
      formData: '',
      languageItems: ['en', 'jp'],
      agree: false,
      formoutDialog: {
        show: false
      },
      isSJL: true,
      params: {
        // username: '',
        // code: '',
        // name: '',
        // fullName: '',
        // englishName: '',
        // showName: '',
        // email: '',
        // position: '',
        // outsideLineNumber: '',
        // insideLineNumber: '',
        // valid: false,
        loginRefused: true
      }
    }
  },
  computed: {
    valid() {
      return this.params.valid && this.dialog.agree
    }
  },
  methods: {
    download() {
      if (this.isSJL) {
        this.sjlPrint()
      } else if (this.params.language == null) {
        this.$message('', 'please fill language')
      } else if (this.params.language == 'en') {
        this.print()
      } else if (this.params.language == 'jp') {
        this.jpPrint()
      }
    },
    apply() {
      if (this.params.hasDownloadApplyTable) {
        this.$http.put(`/employees/${this.params.email}/apply`)
      }
    },
    agreeOrNot() {
      this.dialog.show = false
      if (this.dialog.agree) {
        this.save()
      }
    },
    agreeDialogClose() {
      this.dialog.show = false
    },
    save() {
      this.$http
        .get(`/employees/check-email?email=${this.params.email}`)
        .then(a => {
          if (!a.data) {
            this.$message(
              this.$t('app.messages.errors.title'),
              this.params.email + 'は既に使用されています。'
            )
          } else {
            this.$http
              .post('/employees', { ...this.params })
              .then(res => {
                this.$message(
                  this.$t('app.messages.success.title'),
                  this.$t('app.messages.saveApplicationSuccess')
                )
                let data = res.data
                this.params.valid = false
                this.agree = false
                this.params.hasDownloadApplyTable = data.hasDownloadApplyTable
              })
              .catch(() => {
                this.$message(
                  this.$t('app.messages.errors.title'),
                  this.$t('app.messages.fail')
                )
              })
          }
        })
    },
    print() {
      let pages = [
        {
          name1: null,
          name2: null,
          name3: null,
          name4: null,
          name5: null,
          name6: null,
          name7: null,
          name8: null,
          name9: null,
          name: this.params.fullName,
          showName: this.params.showName,
          englishName: this.params.englishName,
          companyName: this.params.comapnayReferName,
          companyType: null,
          position: this.params.position,
          outsideLineNumber: this.params.outsideLineNumber,
          insideLineNumber: this.params.insideLineNumber,
          email: this.params.email
        }
      ]
      this.$refs.printDlg.popup(pages)
    },
    jpPrint() {
      let pages = [
        {
          name1: null,
          name2: null,
          name3: null,
          name4: null,
          name5: null,
          name6: null,
          name7: null,
          name8: null,
          name9: null,
          name: this.params.fullName,
          showName: this.params.showName,
          englishName: this.params.englishName,
          companyName: this.params.comapnayReferName,
          companyType: null,
          position: this.params.position,
          outsideLineNumber: this.params.outsideLineNumber,
          insideLineNumber: this.params.insideLineNumber,
          email: this.params.email
        }
      ]
      this.$refs.jpPrintDlg.popup(pages)
    },
    sjlPrint() {
      let pages = [
        {
          name1: null,
          name2: null,
          name3: null,
          name4: null,
          name5: null,
          name6: null,
          name7: null,
          name8: null,
          name9: null,
          name: this.params.fullName,
          showName: this.params.showName,
          englishName: this.params.englishName,
          companyName: this.params.comapnayReferName,
          companyType: null,
          bu: null,
          department: null,
          position: this.params.position,
          outsideLineNumber: this.params.outsideLineNumber,
          insideLineNumber: this.params.insideLineNumber,
          email: this.params.email
        }
      ]
      this.$refs.sjlPrintDlg.popup(pages)
    }
  }
}
</script>
